import { prettyError, prettyErrorDescription } from 'constants/errors'
import { useContext, useEffect } from 'react'
import GenericError from 'components/generic-error'
import DynamicPopup from 'components/popUps/DynamicPopup'
import { ContainerError } from 'components/error-view'
import { usePopupContext } from 'hooks/use-main-cass'
import { LoaderContext } from 'contexts/loader-context'
import textServices from 'services/text-services'

interface F1TriviaFailSheetProps {
  code: number | string | null
  /** Restarts the flow on the same trivia (direct access reloads the page) */
  onRetry: () => void
  /** Leaves the trivia and lands back on /pitstops */
  onBackToPitstops: () => void
}

// Campaign fail sheet (Figma 5558:2936): same title/description as the
// theme's 505 error, but the actions belong to the campaign — retry the
// same trivia instead of browsing other trivias, plus a way back to the
// Pit Stops landing. Rendered only for the F1 trivia (see selector.tsx).
const F1TriviaFailSheet = ({ code, onRetry, onBackToPitstops }: F1TriviaFailSheetProps) => {
  const { openPopup } = usePopupContext()
  const { setFooter } = useContext(LoaderContext)

  useEffect(() => {
    setFooter(false)

    openPopup(
      <DynamicPopup isOpen={true} onClose={onBackToPitstops}>
        <ContainerError handleMenu={onBackToPitstops}>
          <GenericError
            error={prettyError(code)}
            description={prettyErrorDescription(code)}
            buttonText={textServices.findByText('pitstops/trivia/failRetry', 'Volver a intentar') as string}
            onRetry={onRetry}
            subButtonText={textServices.findByText('pitstops/trivia/failBack', 'Volver a Pit Stops') as string}
            onSubRetry={onBackToPitstops}
          />
        </ContainerError>
      </DynamicPopup>
    )

    return () => setFooter(true)
  }, [])

  return <></>
}

export default F1TriviaFailSheet
